import { Link } from "react-router-dom";
import { ArrowRight, CalendarDays, MessageCircleQuestion, UsersRound } from "lucide-react";

const points = [
  { icon: CalendarDays, label: "Scheduled around student exam dates" },
  { icon: MessageCircleQuestion, label: "Illinois-focused review and live Q&A" },
  { icon: UsersRound, label: "Small-group workshop interest" },
];

export default function LiveReviewPromo({ source = "product", compact = false }) {
  return (
    <section
      aria-labelledby={`live-review-title-${source}`}
      className={[
        "border border-[color:rgba(10,27,51,0.12)] bg-white",
        compact
          ? "mt-6 border-l-4 border-l-[var(--ibp-gold-500)] p-5"
          : "mt-12 px-6 py-8 sm:px-8 sm:py-10",
      ].join(" ")}
    >
      <div className={compact ? "" : "grid gap-7 lg:grid-cols-[1fr,auto] lg:items-center"}>
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.18em] text-[#9A6A00]">
            Live review and tutoring
          </p>
          <h2
            id={`live-review-title-${source}`}
            className="mt-2 font-[var(--font-heading)] text-xl font-bold text-[var(--ibp-ink)] sm:text-2xl"
          >
            Live Illinois Exam Final Review
          </h2>
          <p className="mt-2 max-w-2xl text-sm leading-6 text-[color:rgba(11,18,32,0.7)]">
            Join the priority list for upcoming small-group review dates and private tutoring
            availability. Share your exam timeline and hardest topic so we can match you with the
            right support.
          </p>
          {!compact ? (
            <ul className="mt-5 grid gap-3 text-sm text-[color:rgba(11,18,32,0.76)] sm:grid-cols-3">
              {points.map(({ icon: Icon, label }) => (
                <li key={label} className="flex items-start gap-2">
                  <Icon className="mt-0.5 h-4 w-4 flex-none text-[#B7791F]" />
                  <span>{label}</span>
                </li>
              ))}
            </ul>
          ) : null}
        </div>

        <div className={compact ? "mt-4" : "lg:text-right"}>
          <Link
            to={`/live-review?source=${source}`}
            className="inline-flex min-h-11 items-center justify-center gap-2 rounded-xl bg-[var(--ibp-navy-950)] px-5 py-3 text-sm font-semibold text-white transition-colors hover:bg-[#10294a] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--ibp-focus-ring)] focus-visible:ring-offset-2"
          >
            Join the priority list <ArrowRight className="h-4 w-4" />
          </Link>
          <p className="mt-2 text-xs text-[color:rgba(11,18,32,0.52)]">
            Priority access. No payment today.
          </p>
        </div>
      </div>
    </section>
  );
}
